"use client"

import { VStack } from "@chakra-ui/react"
import { BLXApplications } from "config/routing"
import type React from "react"
import { selectActiveBmSubId, useAppSelector } from "services"
import { useBMRouteNavigationLinkItems } from "utils/routeBuilders/bm/useBMRouteNavigationLinkItems"
import { NavLinkItem } from "./components"
import AppNavigationContainer from "./components/AppNavigationContainer"
import NavigationAccordion from "./components/NavigationAccordion"

const BrewMenuNavigation: React.FC = () => {
    const activeBmSubId = useAppSelector(selectActiveBmSubId)

    const { brewMenuMainNavConfig, brewMenuSettingsConfig } = useBMRouteNavigationLinkItems()

    const navDisabled = !activeBmSubId || activeBmSubId.length <= 0

    return (
        <AppNavigationContainer app={BLXApplications.BrewMenu}>
            <VStack gap={0} w='full'>
                {brewMenuMainNavConfig.map((application, i) => (
                    <NavLinkItem
                        item={application}
                        key={application.application + i}
                        disabled={navDisabled}
                    />
                ))}
            </VStack>
            <NavigationAccordion
                accordionItems={[{ label: "settings", links: brewMenuSettingsConfig }]}
                disabled={navDisabled}
            />
        </AppNavigationContainer>
    )
}

export default BrewMenuNavigation
